import { Modal } from "components/notifications"
import PropTypes from "prop-types";
import React from "react"
import classNames from 'classnames';

import './VisionAppDisplay.css';

export function VisionAppDisplay(props) {
    return <Modal
        title={null}
        isOpen={props.show}
        isCloseButtonShown={true}
        onClose={props.onClose}
        className={classNames("vision-app", props.className)}
        showCloseButton={true}>
        <div className="mobile-header">
            {props.header}
        </div>
        {props.children}
    </Modal>
}

VisionAppDisplay.propTypes = {
    children: PropTypes.node.isRequired,
    header: PropTypes.node.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    className: PropTypes.string
};
